import React, { useState } from "react";
import Logo from "./navbar/logo";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSignUpLink, getSignInLink } from "../../utils/path-helper";
import "./navbar/btns-group.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import HelpGuideModal from "./help-guide";

const WSHeader = ({ isLogoDisabled }) => {
  const navigate = useNavigate();
  const { locale } = useParams();
  let signUpLink = getSignUpLink(locale, "");
  let signInLink = getSignInLink(locale, window.location.search);
  const [mobileviewNavbar, setMobileviewNavbar] = useState(false);
  const { t } = useTranslation();

  const [isHelpGuideVisible, setIsHelpGuideVisible] = useState(false);

  const toggleHelpGuide = () => {
    if (window.location.href.includes("forgot-password")) {
      navigateSignIn();
    } else {
      setIsHelpGuideVisible((prev) => !prev);
    }
  };
  const navigateSignIn = () => {
    navigate(signInLink);
  };

  return (
    <>
      <header className="header py-1 lg:py-2 border-b border-gray-200">
        <nav className="container mx-auto ">
          <div className="flex justify-between items-center w-full">
            <div>
              <Logo disabled={isLogoDisabled} />
            </div>
            {/* <div id="navbarNavAltMarkup">
              <div className="flex items-center pr-1.5 mt-1">
                <button
                  id="help-guide-btn"
                  className="hidden lg:block text-lg border rounded-3xl border-[#0E77FF] hover:border-[#424a5b] bg-[#0E77FF] hover:bg-[#424a5b] text-white hover:text-white py-2.5 px-4 font-bold uppercase "
                  onClick={toggleHelpGuide}
                >
                  {window.location.href.includes("forgot-password")
                    ? t("sign_up.ps.member_login")
                    : t("generic_text.help_guide")}
                </button>
                <button
                  className="lg:hidden text-gray-400 text-2xl sm:text-3xl sm:mr-2"
                  onClick={() => setMobileviewNavbar((prev) => !prev)}
                >
                  <FontAwesomeIcon icon={faBars} />
                </button>
              </div>
            </div> */}
          </div>
          <div
            className={`w-full lg:hidden transition-all duration-1000 ease-in-out font-bold ${
              mobileviewNavbar ? "max-h-20 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <button
              className="text-base border rounded border-[#0E77FF] hover:border-[#424a5b] bg-[#0E77FF] hover:bg-[#424a5b] text-[#424a5b] hover:text-white font-medium py-3 px-4 w-full text-center mt-4"
              onClick={toggleHelpGuide}
            >
              {window.location.href.includes("forgot-password")
                ? t("sign_up.ps.member_login")
                : t("generic_text.help_guide")}
            </button>
          </div>
        </nav>
      </header>
      <HelpGuideModal toggleHelpGuide={toggleHelpGuide} isHelpGuideVisible={isHelpGuideVisible} />
    </>
  );
};

export default WSHeader;
